/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/jobs/:job_id/errors/request_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiJobsJobIdErrorsRequestExportCacheKeys } from "./constants";
import type { PostIntegrationsDirectCdiJobsJobIdErrorsRequestExportProps, JobsErrorsExportResult } from "./types";

export const postIntegrationsDirectCdiJobsJobIdErrorsRequestExport = reactQueryMutationAdapter(
  integrationsDirectCdiJobsJobIdErrorsRequestExportCacheKeys,
  (props: PostIntegrationsDirectCdiJobsJobIdErrorsRequestExportProps): Promise<JobsErrorsExportResult> => {
    return fetch(`/integrations/direct/cdi/jobs/${props.jobId}/errors/request_export`, "POST", props);
  }
);
